import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-DZ', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(amount) + ' DA';
};

export const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        }).format(date);
    } catch {
        return dateString;
    }
};

export const formatDateShort = (dateString) => {
    if (!dateString) return '-';
    try {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('fr-FR', {
            day: '2-digit',
            month: 'short',
        }).format(date);
    } catch {
        return dateString;
    }
};

export const getStatusLabel = (status) => {
    const labels = {
        nouvelle: 'Nouvelle',
        confirme: 'Confirmée',
        en_attente: 'En Attente',
        injoignable: 'Injoignable',
        rupture_stock: 'Rupture',
        expedie: 'Expédiée',
        livre: 'Livrée',
        annule: 'Annulée',
        retourne: 'Retournée',
        // Legacy statuses
        en_preparation: 'En Préparation',
        disponible: 'Disponible',
        archive: 'Archivé',
    };
    return labels[status] || status;
};

export const getStatusColor = (status) => {
    const colors = {
        nouvelle: 'bg-blue-500 text-white border-blue-600',
        confirme: 'bg-cyan-500 text-white border-cyan-600',
        en_attente: 'bg-amber-500 text-white border-amber-600',
        injoignable: 'bg-rose-500 text-white border-rose-600',
        rupture_stock: 'bg-red-600 text-white border-red-700',
        expedie: 'bg-purple-500 text-white border-purple-600',
        livre: 'bg-green-500 text-white border-green-600',
        annule: 'bg-gray-500 text-white border-gray-600',
        retourne: 'bg-orange-500 text-white border-orange-600',
        // Legacy statuses
        confirme: 'bg-cyan-500 text-white border-cyan-600',
        en_preparation: 'bg-indigo-500 text-white border-indigo-600',
        disponible: 'bg-emerald-500 text-white border-emerald-600',
        archive: 'bg-slate-500 text-white border-slate-600',
    };
    return colors[status] || 'bg-gray-500 text-white border-gray-600';
};

// Status icons mapping
export const getStatusIcon = (status) => {
    const icons = {
        nouvelle: '🆕',
        confirme: '✅',
        en_attente: '⏳',
        injoignable: '📵',
        rupture_stock: '❌',
        expedie: '🚚',
        livre: '📦',
        annule: '🚫',
        retourne: '↩️',
    };
    return icons[status] || '📋';
};

export const getActionLabel = (action) => {
    const labels = {
        inscription: 'Inscription',
        connexion: 'Connexion',
        creation_commande: 'Création de commande',
        modification_commande: 'Modification de commande',
        suppression_commande: 'Suppression de commande',
        configuration_sheets: 'Configuration Google Sheets',
        synchronisation_sheets: 'Synchronisation depuis Sheets',
        export_sheets: 'Export vers Sheets',
        deconnexion_sheets: 'Déconnexion Google Sheets',
    };
    return labels[action] || action;
};
